<template>
  <div v-show="show" class="keyword-planner-result-action-row">
    <span class="keyword-planner-result-action-row__report">
      {{
        $t('ADVERTISEMENT.KEYWORDPLANNER.SELECTED_KEYWORDS', {
          count: selectedSuggestedKeywords.length,
        })
      }}
    </span>
    <div class="keyword-planner-result-action-row__divider" />
    <KeywordPlannerAction />

    <ElButton
      class="keyword-planner-result-action-row__close"
      type="text"
      icon="el-icon-close"
      @click="close"
    />
  </div>
</template>

<script>
import KeywordPlannerAction from './KeywordPlannerAction';

export default {
  name: 'KeywordPlannerResultActionRow',
  components: {
    KeywordPlannerAction,
  },
  provide() {
    return {
      $selectedSuggestedKeywords: () => this.selectedSuggestedKeywords,
    };
  },
  model: {
    prop: 'show',
    event: 'changeShow',
  },
  props: {
    selectedSuggestedKeywords: {
      type: Array,
      required: true,
    },
    show: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    close() {
      this.$emit('changeShow', false);
    },
  },
};
</script>

<style lang="scss">
.keyword-planner-result-action-row {
  display: flex;
  align-items: center;

  height: rem-calc(60px);
  background-color: $lb-color-primary;
  color: #fff;

  padding: $global-padding / 1.6 $global-padding * 1.25;

  &__divider {
    width: 1px;
    background-color: #000;
    align-self: stretch;

    margin: 0 $global-margin * 1.25;
  }

  &__close {
    color: #fff;
    font-size: rem-calc(24px);

    margin-left: auto;
    @include rtl() {
      margin-right: auto;
      margin-left: 0;
    }
  }
}
</style>
